var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 2H1.99967C1.63148 2 1.33301 2.29848 1.33301 2.66667V4.66667C1.33301 5.03486 1.63148 5.33333 1.99967 5.33333H13.9997C14.3679 5.33333 14.6663 5.03486 14.6663 4.66667V2.66667C14.6663 2.29848 14.3679 2 13.9997 2Z",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 5.3335V12.6668C2.66699 13.0205 2.80747 13.3596 3.05752 13.6096C3.30756 13.8597 3.6467 14.0002 4.00033 14.0002H12.0003C12.3539 14.0002 12.6931 13.8597 12.9431 13.6096C13.1932 13.3596 13.3337 13.0205 13.3337 12.6668V5.3335",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 8H9.33366",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNoteIcon);
export default __webpack_public_path__ + "static/media/deleteNoteIcon.107d97d3789ff592787876c2ecfaceb6.svg";
export { ForwardRef as ReactComponent };